import { create } from 'zustand';
import type { ModifierId, SocketSlots } from '../types/modifier.types';
import type { TrinketId } from '../types/trinket.types';

export type { SocketSlots };

interface SocketsState {
  /** Map minor modelId → positioned socket slots. */
  socketed: Record<TrinketId, SocketSlots>;
}

interface SocketsActions {
  socket(minorId: TrinketId, socketIndex: number, modifierId: ModifierId): void;
  unsocket(minorId: TrinketId, modifierId: ModifierId): void;
  clearAll(): void;
  getSocketed(minorId: TrinketId): SocketSlots;
  restore(socketed: Record<string, SocketSlots>): void;
}

export const useSocketsStore = create<SocketsState & SocketsActions>(
  (set, get) => ({
    socketed: {},
    socket: (minorId, socketIndex, modifierId) =>
      set((s) => {
        const list = [...(s.socketed[minorId] ?? [])];
        list[socketIndex] = modifierId;
        return { socketed: { ...s.socketed, [minorId]: list } };
      }),
    unsocket: (minorId, modifierId) =>
      set((s) => {
        const list = [...(s.socketed[minorId] ?? [])];
        const idx = list.indexOf(modifierId);
        if (idx === -1) {
          return s;
        }
        list[idx] = undefined;
        while (list.length > 0 && list[list.length - 1] == null) {
          list.pop();
        }
        return { socketed: { ...s.socketed, [minorId]: list } };
      }),
    clearAll: () => set({ socketed: {} }),
    getSocketed: (minorId) => get().socketed[minorId] ?? [],
    restore: (socketed) => set({ socketed }),
  }),
);
